import { LoadingState, UnauthenticatedState } from "../types";
import { Login, LoginLoading } from "./Login";

type UnauthenticatedScreenProps = UnauthenticatedState | LoadingState;

export function UnauthenticatedScreen(props: UnauthenticatedScreenProps) {
  return props.state === "loading" ? (
    <LoginLoading />
  ) : (
    <Login loginWithRedirect={props.loginWithRedirect} />
  );
}
